module.exports = "/_next/static/images/ComprehensiveFiberSolutions-f11d2ec6ca932293016fc13a46be8018.webp";